import firebase from "firebase/compat/app";
import { ENV } from "../config/ENV";
import candidateLogin from "../services/AuthService";

firebase.initializeApp(ENV.firebaseConfig);
// firebase.auth().onAuthStateChanged(function (user) {
//   if (user) {
//     user.getIdToken().then(function (idToken) {
//       window.localStorage.setItem("authToken", idToken);
//       login();
//     });
//   }
// });

// const login = () => {
//   candidateLogin()
//     .then((response) => {
//       window.sessionStorage.setItem("clickapplybutton", "clickapplybutton");
//       if (response.data !== undefined && response.data !== "") {
//         const loginResposne = response.data;
//         window.localStorage.setItem("user", loginResposne.id);

//         if (loginResposne.email !== null) {
//           window.localStorage.setItem("email", loginResposne.email);
//         }

//         if (loginResposne.firstName !== null) {
//           window.localStorage.setItem("name", loginResposne.firstName);
//         }

//         if (loginResposne.lastName !== null) {
//           window.localStorage.setItem("lastName", loginResposne.lastName);
//         }

//         if (loginResposne.contactNumber !== null) {
//           window.localStorage.setItem(
//             "contactNumber",
//             loginResposne.contactNumber
//           );
//         }
//       }
//     })
//     .catch((error) => {});
// };

const uiConfig = {
  signInFlow: "popup",
  signInOptions: [
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      buttonColor: "white",
      iconUrl: require("../assets/img/images/icon-mail.png"),
      fullLabel: "Continue with Email ",
    },
    {
      provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
      buttonColor: "white",
      iconUrl: require("../assets/img/images/icon-phone.png"),
      fullLabel: "Continue with Phone ",
    },
    {
      provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      buttonColor: "white",
      fullLabel: "Continue with Google ",
    },
  ],
  tosUrl: "https://www.teamanics.com/?section=terms",

  privacyPolicyUrl: "https://www.teamanics.com/?section=privacy",

  callbacks: {
    // Avoid redirects after sign-in.
    signInSuccessWithAuthResult: () => false,
  },
};
export default uiConfig;
